import { navItems, partnerManagerUrl } from '../../routes/routes';
import logo from '../../logo.svg';
import NavLink from './NavLink';

function DesktopHeader({ activePath, isAuthenticated, onAuthToggle }) {
  return (
    <header className="desktop-header">
      <div className="desktop-header__inner">
        <a className="brand-button" href="/" aria-label="말타 홈으로 이동">
          <span className="brand-logo-frame" aria-hidden="true">
            <img src={logo} alt="" />
          </span>
          <span className="brand-name">Marlta</span>
        </a>

        <nav className="desktop-nav" aria-label="주요 메뉴">
          {navItems.map((item) => (
            <NavLink key={item.id} item={item} isActive={activePath === item.path} />
          ))}
        </nav>

        <div className="desktop-header__actions">
          <a
            className="partner-manager-link"
            href={partnerManagerUrl}
            target="_blank"
            rel="noreferrer"
          >
            말타파트너스
          </a>
          <button className="auth-button" type="button" onClick={onAuthToggle}>
            {isAuthenticated ? '로그아웃' : '로그인'}
          </button>
        </div>
      </div>
    </header>
  );
}

export default DesktopHeader;
